import React from "react";
import { YhForm } from "@/components/YhFormBox";
import { FormItemTypeEnum, IYhForm } from "@/components/YhFormBox/Types";
import { useOrgModel } from "../orgModel";

const branchDs = [
    { label: "财务分支", value: "fms" },
    { label: "主分支", value: "main" },
    { label: "供应链分支", value: "scm" },
    { label: "维保分支", value: "vrm" },
]

export const OrganOldForm = () => {
    const { selectedNodes } = useOrgModel();

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        formValues: selectedNodes[0],
        disabled: true,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "数据版本号",
                fieldName: "ver",
                span: 24,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "父级编码",
                fieldName: "pcode",
                disable: true,
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构编码",
                fieldName: "code",
                span: 24,
                disable: true,
                rules: [{ required: true, message: '该项为必填项' }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构名称",
                fieldName: "name",
                span: 24,
                disable: true,
                rules: [{ required: true, message: '该项为必填项' }]
    
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
                disable: true,
            },
        ]
    };


    return (
        <>
            <div className="dict-list-header">
                {/* <Button type="link" shape="round" onClick={onSubmit}>保存</Button>
                <Button type="link" shape="round" onClick={() => setSelectedNodes([])}>取消</Button> */}
            </div>
            <div className="dict-from-content">
                <YhForm {...formConfig} />
            </div>
        </>
    )
}